import React from 'react';
import { number } from 'prop-types';
import { Box, Typography } from '@mui/material';
import { I18n } from 'utils/i18n';

const PeopleSelected = ({ selected }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', pr: '5px' }}>
    {selected > 0 ? (
      <div>
        <Typography sx={{ fontWeight: 600 }} component="div" color="primary" variant="subtitle1">
          <span>
            {selected} {I18n.t('TeamDrawer.EmployeesTable.people selected')}
          </span>
        </Typography>
      </div>
    ) : null}
  </Box>
);
PeopleSelected.propTypes = {
  selected: number.isRequired,
};

export default PeopleSelected;
